import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { CustomerLogsResponseDataSchema, DataResponseWithPagination } from "schema"
import { z } from "zod"

type Response = DataResponseWithPagination<z.infer<typeof CustomerLogsResponseDataSchema>>

const getCustomerLogsQueryKey = (customerId: string) => ["customer-logs", customerId]

export const customerLogsQuery = (customerId: string) =>
  queryOptions({
    queryKey: getCustomerLogsQueryKey(customerId),
    queryFn: async () => {
      const response = await axios.get<Response>(`/customers/${customerId}/logs`, {
        params: { page: 1, total: 100 },
      })

      return response.data.data
    },
  })
